import * as React from 'react';
import { trackBannerClick, trackBannerScroll } from './tracking';

export const useTracking = (visible: boolean) => {
  React.useEffect(() => {
    if (visible) {
      trackBannerScroll();
    }
  }, [visible]);

  const trackClick = React.useCallback(() => {
    trackBannerClick();
  }, []);

  return { trackClick };
};
